import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';

import AddWholesale from './AddWholesale.react';
import AddWholesaleBulk from './AddWholesaleBulk.react';
import PromptCouponValue from './PromptCouponValue.react';

class Increase extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false
        };

        // this.incOptions = this.incOptions.bind(this);
        // this.confirmLastFour = this.confirmLastFour.bind(this);
        // this.increase = this.increase.bind(this);
    }

    componentWillUnmount() {
        $('.pos-sidebar').css({ 'z-index' : 2 });
    }

    incOptions() {

    }

    render() {
        var self = this;

        var item      = this.props.item;
        var guest     = this.props.guest;
        var page      = this.props.page;

        return (
            <div className='info-btn'>
                <div
                    className={'info-btn__btn '}
                    onClick={() => { PopupActions.open('product-information', item, guest) }}>

                    <i className='fa fa-info' aria-hidden='true' />
                </div>

            </div>

        );
    }
}

export default Increase;


/*

                { this.state.confirmLastFour &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content increase__last-four'>
                            <div className='popup-header'>
                                LAST 4 DIGITS

                                <div
                                    className='popup-close'
                                    onClick={() => { self.setState({ confirmLastFour : false, lastFour : '' }); }}>

                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            <input
                                type='text'
                                id='last-four'
                                value={this.state.lastFour}
                                onChange={(e) => { this.setState({ lastFour : e.target.value }); }} />

                            <div
                                className='increase__last-four--go'
                                onClick={this.confirmLastFour}>

                                OK
                            </div>
                        </div>

                    </div>
                }

                { this.state.addWholesale &&
                    <AddWholesale
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ addWholesale : false }); }} />
                }

                { this.state.addWholesaleBulk &&
                    <AddWholesaleBulk
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ addWholesaleBulk : false }); }} />
                }

                { this.state.promptCouponValue &&
                    <PromptCouponValue
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ promptCouponValue : false }); }} />
                }

*/


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/InfoButton.react.jsx